import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CONTACT_IMPORT_FORM_SCHEMA = yup.object().shape({
  

});

